import { Component, OnInit, Input} from '@angular/core';
import { TeiasoftLoaderService } from '../../services/teiasoft-bucket/teiasoft-loader.service'

@Component({
  selector: 'teiasoft-loader',
  templateUrl: './teiasoft-loader.component.html',
  styleUrls: ['./teiasoft-loader.component.scss']
})

export class TeiasoftLoaderComponent implements OnInit {
  @Input() spinnerImage: string = "../../assets/images/Logo_DMV_2024-Square.png"; //"../../assets/images/toro_white.png";
  top:number=0;
  constructor(private teiasoftLoaderService: TeiasoftLoaderService){
    this.teiasoftLoaderService.teiasoftLoaderStart$.subscribe(
      (res) => {
        const tLoader = document.getElementById("tLoader");
        if (!tLoader) return;
  
        if (res === 'show'){
          // Make sure it is displayed, then fade in
          tLoader.style.display = "flex"; 
          tLoader.classList.add("tl-visible");
        } else {
          // Fade out
          tLoader.classList.remove("tl-visible");
  
          // Optionally, after the transition finishes, hide it.
          setTimeout(() => {
            tLoader.style.display = "none";
          }, 250);
        }
      });
  }

  ngOnInit(): void {

  }

}
